import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import i18n from './i18n';
import API from './api';
import reportWebVitals from './reportWebVitals';
import './index.css';

function isTokenUsable(token) {
  if (!token || typeof token !== 'string') return false;
  const parts = token.split('.');
  if (parts.length !== 3) return false;
  try {
    const payload = JSON.parse(window.atob(parts[1]));
    if (!payload || !payload.exp) return true;
    const nowSec = Math.floor(Date.now() / 1000);
    return payload.exp > nowSec;
  } catch (_) {
    return false;
  }
}

async function init() {
  try {
    const token = localStorage.getItem('token');
    if (isTokenUsable(token)) {
      const res = await API.get('profile/me/', { skipAuthRedirect: true });
      const lang = res.data?.language || localStorage.getItem('preferred_language') || 'en';
      await i18n.changeLanguage(lang);
    } else {
      if (token) {
        localStorage.removeItem('token');
      }
      const fallbackNoToken = localStorage.getItem('preferred_language') || 'en';
      await i18n.changeLanguage(fallbackNoToken);
    }
  } catch (e) {
    // fallback: use stored preferred_language if present, else keep current i18n language
    const fallback = localStorage.getItem('preferred_language');
    if (fallback) await i18n.changeLanguage(fallback);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
